import { AnnouncementManagement } from "@/components/admin/AnnouncementManagement";

export default function AnnouncementsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Announcement Management</h2>
        <p className="text-muted-foreground">Manage announcements from all organizations</p>
      </div>
      <AnnouncementManagement />
    </div>
  );
}
